<template>
    <div style="background:white; height:100%">
    <div :style="{'background':'white',height:divhigh }">
        <div class="headbar">
            <span style="font-size:12px; font-weight:600;margin-left:5px;margin-right:3px">国家</span>
            <el-select multiple v-model="areano" clearable @change="areaChg"  placeholder="请选择" size="small" style="width:260px; height:35px;">
                <span v-for="item in counArr" :key='item.key'>
                    <el-option :label="item.SUBNM" :value="item.SUBNO" style="width:170px;"></el-option>
                </span>
            </el-select>
            <span style="font-size:12px; clearable font-weight:600;margin-left:5px;margin-right:3px">店铺名称</span>
            <el-select multiple v-model="shopid"  placeholder="请选择店铺" size="small" style="width:340px;height:35px;">
                <span v-for="item in shopArr" :key='item.key'>
                    <el-option :label="item.CNAME" :value="item.CODE" style="width:200px;"></el-option>
                </span>
            </el-select>
            <span style="font-size:12px;  font-weight:600;margin-left:5px;margin-right:3px">SKU</span>
            <el-input clearable  v-model="asinno" size="small" style="width:120px;margin-left:2px; "></el-input>
            <span style="font-size:12px;  font-weight:600;margin-left:20px;margin-right:3px">退货年份</span>
            <!-- <el-date-picker :editable="false" :clearable="false" type="date" size="small"  v-model="frdttm"  value-format="yyyy-MM-dd" style="width:130px" ></el-date-picker>  
            <span style="font-size:12px;  font-weight:600;margin-left:5px;margin-right:5px">-</span>
            <el-date-picker :editable="false" :clearable="false" type="date" size="small"  v-model="todttm"  value-format="yyyy-MM-dd" style="width:130px;margin-right:15px;" ></el-date-picker>   -->
            <el-select   v-model="rtnyr"  placeholder="请选择" size="small" style="width:100px;height:35px;">
                <span v-for="item in yrArr" :key='item.key'>
                    <el-option :label="item.CNAME" :value="item.CODE" style="width:100px;"></el-option>
                </span>
            </el-select>
            <el-button size="mini" type="primary" icon="iconfont icon-gaojichazhao2" @click="qryTabData" style="width:70px;height:35px;margin-left:10px; "><span style="margin-left:5px;font-size:12px">查询</span></el-button>    
            <el-button size="mini" type="primary" icon="iconfont icon-shuaxin" @click="refData" style="width:90px;height:35px;margin-left:20px; "><span style="margin-right:5px;font-size:12px">刷新数据</span></el-button>
        </div>
        <!-- 明细资料 -->
        <split-pane  :min-percent='10' :default-percent='32' split="vertical">
            <template slot="paneL">
                <el-table  :data="rtnData" 
                    border     
                    ref="reftab"     
                    class="custom-table-border"                  
                    size="small"
                    :cell-style="{padding:'2px'}"
                    :header-cell-style="{'height':'22px'}"
                    :height="tabHeight" 
                    :row-key="getRowKey"
                    highlight-current-row
                    show-summary
                    :summary-method="getSummary"
                    style="overflow:auto;margin-top:1px;"> 
                    <!-- <el-table-column label="序号" type="index" width="50" fixed></el-table-column>  -->
                    
                    <el-table-column  v-for="(item,index ) in tabArr.filter(item=>item.thide=='N')" :key="index" 
                        :prop="item.key"
                        :label="item.title"
                        :fixed="item.key=='SKU'"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'"
                        :min-width="item.width">
                    </el-table-column> 
 
                </el-table>              
            </template>
            <template slot="paneR">
                <div style="display:flex" > 
                    <div :style="{'margin-left':'2px',width:'470px'}">
                        <div style="width:470px;line-height:30px;background:#f7f8f9;color:409eef;font-weight:600; ">
                           <i class="iconfont icon-xuanze1" style="color:#389"></i> <span style="padding-left:6px;font-size:14px">买家退货原因</span>
                        </div>
                        <div  :style="{ border:'1px solid #ccc',height:piehigh,'overflow-y':'auto'  }">
                            <div  id="rtnPie" ></div>
                        </div>
                    </div>
                    <div :style="{'margin-left':'5px',width:'380px'}">
                        <div style="width:380px;line-height:30px;background:#f7f8f9;color:409eef;font-weight:600; ">
                           <i class="iconfont icon-xuanze1" style="color:#389"></i> <span style="padding-left:6px;font-size:14px">库存属性</span>
                        </div>
                        <div  :style="{ border:'1px solid #ccc',height:piehigh,'overflow-y':'auto'  }">
                            <div  id="stkPie" ></div>
                        </div>
                    </div>
                    <div :style="{'margin-left':'5px',width:'380px'}">
                        <div style="width:380px;line-height:30px;background:#f7f8f9;color:409eef;font-weight:600; ">
                           <i class="iconfont icon-xuanze1" style="color:#389"></i> <span style="padding-left:6px;font-size:14px">状态</span>
                        </div>
                        <div  :style="{ border:'1px solid #ccc',height:piehigh,'overflow-y':'auto'  }">
                            <div  id="stfgPie" ></div>
                        </div>
                    </div>
                </div>
            </template>
        </split-pane>
         
        <!-- 提示框 -->
        <el-dialog :visible.sync="promptWin" v-dialogDrag width="450px" append-to-body :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div> 
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>
    </div>
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user';
import { getDate} from '../../api/Select'  
//局部注册
export default {
    name:"return_analysis",
    data () {
        return {   
            v_cnt :0,
            rtnData:[],
            frdttm:'',
            todttm:'',
            asinno:'',
            rtnyr:'',
            yrArr:[],
            shopid:'', 
            loadWin:false,
            tempData:[],    
            v_sumamt:0,
            promptWin:false,
            prompt:'',
            operArr:[],
            stkName:[],
            stkData:[],
            pieData:[],
            pieName:[],
            stfgData:[],
            stfgName:[],
            tabArr:[], //表列   
            v_amt:0,
            v_sumqty:0,
            shopArr:[],  
            oper:'like',
            txtparam:'',
            selparam:'',  
            exArr:[] , //交易费用
            transArr:[],
            taxArr:[],
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_bsurl:'xuper_auth/getTableRecMany'  ,       
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            counArr:[],    
            areano:'',
            v_area:'',
            v_inleft:'',
            myCircle:null,
            myCircle2:null,
            myCircle3:null,
            v_qty:0,
        }
    },
    mounted () { 
        //操作符
        getBaseData(this.v_bsurl,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
        getBaseData(this.v_bsurl,'','','','','V_RTN_YEAR','').then(res=>{
            this.yrArr =res.result
            if (res.result.length>0){
                this.rtnyr =res.result[0]['CODE']
            }
        })
        //店铺
        getBaseData(this.v_bsurl,'PARENTNO','22363','','','v_sys_base','').then(res=>{
            let temp =res.result
            temp.forEach(item=>{
                let v_bool =true
                this.counArr.some(it=>{
                    if (it.SUBNO==item.SUBNO){
                        v_bool =false
                    }
                })
                if (v_bool){
                    this.counArr.push({SUBNO:item.SUBNO,SUBNM:item.SUBNO2})
                }
            })
        })
    },
    computed: {
        divhigh: function() {
            return (window.innerHeight - 90) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 125) + 'px';
        }, 
        piehigh: function() {
            return (window.innerHeight - 165) + 'px';
        },
 
    },
    components: {
     
    },
    created () {       
        if (this.v_username){ 
            //查询数据
 
            this.getTabField() //表列字段
            // this.frdttm =getDate('yr')+'-01-01'
            // this.todttm=getDate('day')
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    watch: {
 
    },
    methods: {
        getSummary(param){
            let v_qtypct =(this.v_sumqty!==0?(this.v_qty/this.v_sumqty*100).toFixed(1)+'%':'')
            let v_amtpct =(this.v_sumamt!==0?(this.v_amt/this.v_sumamt*100).toFixed(1)+'%':'')
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='共'+this.v_cnt+'条记录'
                    return
                }
                if (index===3){
                    sums[index] = v_qtypct
                    return 
                }
                if (index===6){
                    sums[index] = v_amtpct
                    return 
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY'||column.property==='SALEQTY' ||column.property==='AMT'||column.property==='SALEAMT'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            if (column.property==='QTY'||column.property==='SALEQTY'){
                                return Number(Number(prev) +Number(curr) ) 
                            }else{
                                return Number(Number(prev) +Number(curr) ).toFixed(2)
                            }
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        getRowKey(row){
            return row.IDSEQ
        },
        //刷新数据
        refData(){  
            this.$confirm('你确定要刷新数据吗，可能要等待30秒左右','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.loadWin=true
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/refreshRtnCost',
                    data: { 'corpid' :this.v_corpid  },
                }).then(res=>{ 
                    this.loadWin=false
                    this.qryTabData()
                })
            }).catch(()=>{})
        },
        circleEcharts() {
            // 饼图
            const option = {
                legend: {
                    // 图例
                    data: this.pieName,
                    //right: "20px",
                    //top: "5px",
                    x:'left',   //left,right,center
                    y:'top' , //top ,center,bottom
                    bottom:"900",
                    orient: "vertical" //vertical ,horizontal
                },
                title: {
                    // 设置饼图标题，位置设为顶部居中
                    text: '',//"买家退货原因",
                    top: "0%",
                    left: "center"
                },
                series: [
                    {
                        type: "pie",
                        label: {
                            show: true,
                            formatter: "{c} " // b代表名称，c代表对应值，d代表百分比 {b} : {c} ({d}%)
                        },
                        radius: ['70%','45%'] ,// "30%", //饼图半径
                        data: this.pieData
                    }
                ]
            }
            let myChart =document.getElementById("rtnPie")
            myChart.style.width =  "420px";
            myChart.style.height =  "1220px";
            myChart.style.bottom =  "10px";
            myChart.style['margin-left'] =  "10px";
            this.myCircle = this.$echarts.init(myChart);
            this.myCircle.setOption(option);
        },
        //选择国家时 触发店铺
        areaChg(val){
            this.v_area = ''
            val.forEach(item=>{
                if(this.v_area==''){
                    this.v_area ='\''+item+'\''
                }else{
                    this.v_area =this.v_area+','+'\''+item+'\''
                }
            })           
            this.shopid =''
            this.shopArr=[]
            getBaseData(this.v_bsurl,'PARENTNO','22363','','','v_sys_base',' and subno in ('+this.v_area+')').then(res=>{
                this.shopArr =res.result
            })
        },
 
        //查询
        qryTabData(){
            let v_cond =''
            let v_shop =''
            if (this.shopid!==''){
                this.shopid.forEach(item=>{
                    if(v_shop==''){
                        v_shop ='\''+item+'\''
                    }else{
                        v_shop =v_shop+','+'\''+item+'\''
                    }
                })  
            }
            if (v_shop.length>0 ){
                v_cond =' and shopid in ('+v_shop+') and areano in ('+this.v_area+') '
            }else if (v_shop.length==0 && this.areano.length>0){
                v_cond =' and areano in ('+this.v_area+') '
            } 
            let cond_ =v_cond + ' and corpid='+this.v_corpid +' and yr=\''+this.rtnyr +'\' and lower(sku) like lower(\'%'+this.asinno+'%\')'
            this.loadWin =true
            this.rtnData =[]
            this.v_qty =0 
            this.v_sumqty=0
            this.v_amt =0
            this.v_sumamt=0
            // 国家、店铺退货数量 ASIN 分组查询    
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: { p_cond:'select sku ,sum(to_number(qty)) qty, sum(to_number(NVL(saleqty,0)))  saleqty,ROUND(sum(to_number(AMT)),2) AMT,ROUND(sum(to_number(nvl(saleAMT,0))),2) saleAMT,max(skudesc) prdnm from V_ASIN_RETURN where 1=1 '+cond_+' group by sku' },
            }).then(res=>{ 
                if (res.code=='200'){ 
                    this.v_cnt =res.result.length
                    res.result.forEach( item=>{
                        this.v_qty =Number(this.v_qty)+Number(item['QTY'])
                        this.v_sumqty =Number(this.v_sumqty)+Number(item['SALEQTY'])
                        this.v_amt =(Number(this.v_amt)+Number(item['AMT'])).toFixed(1)
                        this.v_sumamt =Number(this.v_sumamt)+Number(item['SALEAMT'])
                        let obj={}  
                        let qtypct = item['SALEQTY']!==0?(item['QTY']/item['SALEQTY']*100).toFixed(1)+'%' :'0%'
                        let amtpct = item['SALEAMT']!==0?(item['AMT']/item['SALEAMT']*100).toFixed(1)+'%' :'0%'                     
                        Object.assign(obj,{SKU:item['SKU'],QTY:item['QTY'],SALEQTY:item['SALEQTY'] ,QTYPCT:qtypct,AMT:item['AMT'],SALEAMT:item['SALEAMT'] ,AMTPCT:amtpct,SKUDESC:item['PRDNM']})
                        this.rtnData.push(obj)
                    })
                    this.loadWin =false
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.reftab.doLayout();
                    })
                }else{
                    this.loadWin =false
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
            this.pieName=[],this.pieData=[]
            // 2、买家退货原因分组
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: { p_cond:'select rsn,sum(to_number(qty)) qty,max(rsnm) rsnm from V_AMZ_RETURN where 1=1 '+cond_+' group by rsn order by max(rsnid)' },
            }).then(res=>{ 
                for(let k=0;k<res.result.length;k++){
                    this.pieName.push( res.result[k]['RSNM']+'('+res.result[k]['QTY']+')'+' '+res.result[k]['RSN'])
                    this.pieData.push({name:res.result[k]['RSNM']+'('+res.result[k]['QTY']+')'+' '+res.result[k]['RSN'],value: res.result[k]['QTY']})
                }
                this.circleEcharts() 
            })
            this.stkName=[],this.stkData=[]
            // 3、买家退货库存属性分析
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: { p_cond:'select STKPROP,sum(to_number(qty)) qty,max(STKPROPnm) STKPROPnm from V_AMZ_RETURN where 1=1 '+cond_+' group by STKPROP order by max(stkpropid)' },
            }).then(res=>{ 
                for(let k=0;k<res.result.length;k++){
                    this.stkName.push( res.result[k]['STKPROPNM']+'('+res.result[k]['QTY']+')'+' '+res.result[k]['STKPROP'])
                    this.stkData.push({name:res.result[k]['STKPROPNM']+'('+res.result[k]['QTY']+')'+' '+res.result[k]['STKPROP'],value: res.result[k]['QTY']})
                }
                this.circleStk() 
            })
            this.stfgName=[],this.stfgData=[]
            // 4、买家退货 状态分析
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getFreeData',
                data: { p_cond:'select STFG,sum(to_number(qty)) qty,max(STFGNM) STFGNM from V_AMZ_RETURN where 1=1 '+cond_+' group by STFG order by max(STFGID)' },
            }).then(res=>{ 
                for(let k=0;k<res.result.length;k++){
                    this.stfgName.push( res.result[k]['STFGNM']+'('+res.result[k]['QTY']+')'+' '+res.result[k]['STFG'])
                    this.stfgData.push({name:res.result[k]['STFGNM']+'('+res.result[k]['QTY']+')'+' '+res.result[k]['STFG'],value: res.result[k]['QTY']})
                }
                this.circleStfg() 
            })
        },
        circleStk() {
            // 饼图
            const option = {
                legend: {
                    // 图例
                    data: this.stkName,
                    //right: "20px",
                    //top: "5px",
                    x:'left',   //left,right,center
                    y:'top' , //top ,center,bottom
                    orient: "vertical" //vertical ,horizontal
                },
                title: {
                    // 设置饼图标题，位置设为顶部居中
                    text: '',//"买家退货原因",
                    top: "0%",
                    left: "center"
                },
                series: [
                    {
                        type: "pie",
                        label: {
                            show: true,
                            formatter: "{c} " // b代表名称，c代表对应值，d代表百分比 {b} : {c} ({d}%)
                        },
                        radius: ['70%','45%'] ,// "30%", //饼图半径
                        data: this.stkData
                    }
                ]
            }
            let myChart =document.getElementById("stkPie")
            myChart.style.width =  "340px";
            myChart.style.height =  "550px";
            myChart.style['margin-left'] =  "10px";
            this.myCircle2 = this.$echarts.init(myChart);
            this.myCircle2.setOption(option);
        },
        circleStfg() {
            // 饼图
            const option = {
                legend: {
                    // 图例
                    data: this.stfgName,
                    x:'left',   //left,right,center
                    y:'top' , //top ,center,bottom
                    orient: "vertical" //vertical ,horizontal
                },
                title: {
                    // 设置饼图标题，位置设为顶部居中
                    text: '',//"买家退货原因",
                    top: "0%",
                    left: "center"
                },
                series: [
                    {
                        type: "pie",
                        label: {
                            show: true,
                            formatter: "{c} " // b代表名称，c代表对应值，d代表百分比 {b} : {c} ({d}%)
                        },
                        radius: ['70%','45%'] ,// "30%", //饼图半径
                        data: this.stfgData
                    }
                ]
            }
            let myChart =document.getElementById("stfgPie")
            myChart.style.width =  "340px";
            myChart.style.height =  "550px";
            myChart.style['margin-left'] =  "10px";
            this.myCircle3 = this.$echarts.init(myChart);
            this.myCircle3.setOption(option);
        },
        //获取表列字段
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','127845','lstseq','1931','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
    .left{
        text-align:left;
        padding-left:6px;
        width:100%; 
    }
    .right{
        text-align:right;
        padding-right:6px;
        width:100%;
    }
    .headbar{
        padding-left:5px; 
        line-height:32px;
        background:#fff;
        overflow: auto;
        padding-top:2px;
        display:flex;
        border-bottom:2px solid #389;
        height:40px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .item-width2  {
        width: 97%;
    } 
    .active { 
        color:#D200D2; 
    } 
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
 